module.exports = __webpack_public_path__ + "static/media/icon-facebook-light.e25ff70d.svg";